import React from 'react';
import { hackyServerSideTranslations } from '../i18nNext';
import { buildLoggedInOnlyLayout } from '../components/layout/layoutBuilder';
import Community from '../components/community/Community';
import { useUserContext } from '../components/auth/hook/userContext';
import TerritoryContent from '../components/territory/TerritoryContent';

const CommunityPage = () => {
  const user = useUserContext();
  if (user.isClient()) {
    return <TerritoryContent onlyFor={['io', 'ch']} render={() => <Community />} />;
  }
  return <Community />;
};

export async function getStaticProps({ locale }) {
  const i18nConfig = await hackyServerSideTranslations(locale);
  return { props: { ...i18nConfig } };
}

CommunityPage.getLayout = buildLoggedInOnlyLayout();
export default CommunityPage;
